"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const messagesMap_1 = __importDefault(require("./messagesMap"));
const isDetailedExportedProvider_1 = __importDefault(require("./validation/isDetailedExportedProvider"));
const getModuleMetadata_1 = require("./metadata/getModuleMetadata");
function createExportedProviderRef(Module, exportedProvider) {
    const metadata = (0, getModuleMetadata_1.getModuleMetadata)(Module);
    const exportedProviderRefs = [];
    const detailedExportedProvider = ((0, isDetailedExportedProvider_1.default)(exportedProvider)
        ? exportedProvider
        : {
            provide: exportedProvider,
            deep: false,
            multiple: false,
        });
    const isBound = detailedExportedProvider.deep
        ? metadata.container.isProvided(detailedExportedProvider.provide) &&
            metadata.container.isImported(detailedExportedProvider.provide)
        : metadata.container.isProvided(detailedExportedProvider.provide);
    const getValue = () => {
        const results = [];
        results.push(...metadata.container.getAllProvided(detailedExportedProvider.provide));
        if (detailedExportedProvider.deep) {
            results.push(...metadata.container.getAllImported(detailedExportedProvider.provide));
        }
        return results.length === 1 ? results[0] : results;
    };
    if (isBound) {
        exportedProviderRefs.push({
            multiple: !!detailedExportedProvider.multiple,
            provide: detailedExportedProvider.provide,
            getValue,
        });
    }
    else {
        throw new Error(messagesMap_1.default.notBoundProviderExported(Module.name, detailedExportedProvider.provide.toString()));
    }
    return exportedProviderRefs;
}
exports.default = createExportedProviderRef;
